import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NavigateRoutes, RequestType, StorageConstants } from 'common/constants/app.constant';
import { RouteMessage } from 'common/models/utilitymodels/base.model';
import { SystemService } from 'common/services/core_services/system.service';

@Injectable({
    providedIn: 'root',
})
export class PreloginGuard implements CanActivate {
    constructor(private systemService: SystemService) { }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        let isLoggedIn = this.systemService.getLocalStorage(StorageConstants.userProfile);
        if (state.url.includes('/view-content')) {
            return true;
        }
        if (!isLoggedIn || this.systemService.deviceInfo.platform !== 'web') {
            return true;
        } else {
            const routeMessage = new RouteMessage();
            routeMessage.type = RequestType.ID;
            this.systemService.routeByUrl(NavigateRoutes.distributordashboard, routeMessage);
        }
    }
}
